import { PlansContainer, PlansItem } from "./Plans.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { PricingActualPlans } from "../../../interfaces";
import { useTranslation } from "react-i18next";
import { ServiceName } from "../../../constants";

interface PlansProps {}

export const Plans = observer(({}: PlansProps) => {
	const { pricingActualStore } = useStores();

	const { t } = useTranslation();

	const plans = Object.entries(PricingActualPlans);

	const handleOnChangePlans = (title: PricingActualPlans, value: number) => {
		pricingActualStore.setPlans(title);
		pricingActualStore.setPlanId(value);
	};

	return (
		<PlansContainer>
			{plans.map(([key, value], index) => {
				return (
					<PlansItem
						key={key}
						$isActive={pricingActualStore.plans === value}
						onClick={() => handleOnChangePlans(value, index + 1)}
					>
						{t(`services.${key.toLowerCase() as ServiceName}`)}
					</PlansItem>
				);
			})}
		</PlansContainer>
	);
});
